import * as React from 'react';
import { useEffect } from 'react';
import { OneDriveConsts } from './one-drive-const';

export const OneDriveCallbackPage = () => {
  useEffect(() => {
    if (document.getElementById('onedrive-js-callback')) return;

    const script = document.createElement('script');
    script.src = OneDriveConsts.SCRIPT_URL;
    script.id = 'onedrive-js-callback';
    document.body.appendChild(script);
  }, []);

  return <div></div>;
};
